import { render, staticRenderFns } from "./footer-newsletter.vue?vue&type=template&id=514cd8bc"
import script from "./footer-newsletter.vue?vue&type=script&lang=ts"
export * from "./footer-newsletter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports